import {isBrowser} from 'helpers/isBrowser';

export const deleteCookie = (name) => {
	if (typeof document === 'undefined') return;

	window.document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
};
